// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__O27wD","itemTitle":"ClientEmergencyInfo_itemTitle__1GwdV","itemText":"ClientEmergencyInfo_itemText__1OMp5"};